import { render, staticRenderFns } from "./ThreeBySixByThree.vue?vue&type=template&id=196f3f0e&scoped=true"
import script from "./ThreeBySixByThree.vue?vue&type=script&lang=js"
export * from "./ThreeBySixByThree.vue?vue&type=script&lang=js"
import style0 from "./ThreeBySixByThree.vue?vue&type=style&index=0&id=196f3f0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196f3f0e",
  null
  
)

export default component.exports